import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useSelector } from "react-redux";

const RecursiveRender = ({ children, listCheckHandler, categoriesList }) => {
    const basicPadding = 40;
    // const style= {{ marginLeft: `${basicPadding * category.level}px`, marginRight: '15px' }}

    return (
        <>
            {children.map((category) => {
                return (
                    <>
                        <tr className="crow">
                            <td className="d-flex" style={{ marginLeft: `${basicPadding * category.level}px` }}>
                                <i className="bi bi-list mx-1"></i>
                                <div className="custom-control custom-checkbox mx-1">
                                    <input
                                        type="checkbox"
                                        className="form-check-input mx-1"
                                        checked={categoriesList.includes(category.id.toString())}
                                        value={category.id}
                                        onChange={(e) => listCheckHandler(e)}
                                    />
                                    <label className="custom-control-label">&nbsp;</label>
                                </div>
                                <Link to={"/category/" + category.id}>{category.title}</Link>
                            </td>
                            {/* <td style={{ width: "25px", padding: "8px 0" }}><i className="bi-info-circle"></i></td>
                    <td style={{ width: "25px", padding: "8px 0" }}><i className="bi bi-arrow-left-right"></i></td>
                    <td style={{ width: "25px", padding: "8px 0" }}><i className="bi bi-card-checklist"></i></td> */}
                        </tr>
                        {category.children && (
                            <RecursiveRender
                                children={category.children}
                                listCheckHandler={listCheckHandler}
                                categoriesList={categoriesList}
                            />
                        )}
                    </>
                );
            })}
        </>
    );
};

const Categories = () => {
    const permissions = useSelector((state) => state.status.permissions);

    const { data: categories, refetch: refetchCategories } = useGetPageQuery("categories");
    const [deleteCategories, { isLoading, isError }] = useSendFormMutation();

    const [categoriesList, setCategoriesList] = useState([]);

    const listCheckHandler = (e) => {
        if (e.target.checked && e.target.value) {
            setCategoriesList([...categoriesList, e.target.value]);
        } else if (!e.target.checked && e.target.value) {
            setCategoriesList([...categoriesList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteCategoriesHandler = async () => {
        for (const categories of categoriesList) {
            await deleteCategories({ body: {}, url: "categories/" + categories, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchCategories();
    };

    const checkAllHandler = () => {
        setCategoriesList(categories.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            refetchCategories();
        };
        refetch();
    }, []);

    return (
        <>
            {categories && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>Категорії</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to={"/category"} className="add btn btn-primary">
                                        Додати Категорію
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <a className="check_all" onClick={checkAllHandler}>
                            Виділити все
                        </a>
                        <table className="table table-striped mt-3">
                            <tbody>
                                <RecursiveRender
                                    children={categories}
                                    listCheckHandler={listCheckHandler}
                                    categoriesList={categoriesList}
                                />
                            </tbody>
                        </table>
                        {permissions.includes("category_edit") || permissions.includes("all") ? (
                            <div className="d-flex">
                                <select name="action" className="form-select" style={{ width: "auto" }}>
                                    <option value="delete">Видалити</option>
                                </select>
                                <button className="btn btn-info mx-3" onClick={deleteCategoriesHandler}>
                                    {isLoading ? "Завантаження" : "Виконати"}
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
};

export default Categories;
